import { render, staticRenderFns } from "./SideForm.vue?vue&type=template&id=4736519c"
import script from "./SideForm.vue?vue&type=script&lang=js"
export * from "./SideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports